import { combineReducers } from "redux"
import main from "./main"
import hash from "./hash"

export default combineReducers({
	main,
	hash,
})
